import "./assets/scss/common.scss";
import "./assets/scss/font.scss";

import { createApp } from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";
import i18n from "./i18n";
import ElementPlusPlugin from "./plugins/element-plus";

const app = createApp(App);
app.use(store);
app.use(router);
app.use(i18n);
app.use(ElementPlusPlugin);

app.mount("#app");

//触发预渲染
document.addEventListener("DOMContentLoaded", function () {
    document.dispatchEvent(new Event("render-event"));
});
